export default __webpack_public_path__ + "static/media/shipment.e9f3ba29.svg";